import { library } from '@fortawesome/fontawesome-svg-core'
import { fab } from '@fortawesome/free-brands-svg-icons'
import { fal } from '@fortawesome/pro-light-svg-icons'
import { far } from '@fortawesome/pro-regular-svg-icons'
import { fas } from '@fortawesome/pro-solid-svg-icons'
import { createBrowserHistory } from 'history'
import * as LogRocket from 'logrocket'
import * as React from 'react'
import 'react-datepicker/dist/react-datepicker.css'
import * as ReactDOM from 'react-dom'
import { Provider } from 'react-redux'
import { ConnectedRouter } from 'connected-react-router'
import 'react-virtualized/styles.css'
import Notifications from './components/Notifications'
import configureStore from './configureStore'
import * as hbApp from './hb-app'
import { routes } from './routes'
import './styles/site.scss'
import { prepareNotificationsSocket } from './utils/notificationsSocket'
import { prepareRequest } from './utils/request'

const logRocketOpts: any = {
  console: {
    shouldAggregateConsoleErrors: true,
  },
}

if (hbApp.isProduction) {
  LogRocket.init('qpx5pa/hb-app', logRocketOpts)
}

library.add(far, fal, fab, fas)

// Create browser history to use in the Redux store
const baseUrl = document.getElementsByTagName('base')[0].getAttribute('href')!
const history = createBrowserHistory({ basename: baseUrl })

// Load the initial state and then render the app
const store = configureStore(history)

prepareRequest(store)
prepareNotificationsSocket(store)

function renderApp() {
  // This code starts up the React app when it runs in a browser. It sets up the routing configuration
  // and injects the app into a DOM element.
  ReactDOM.render(
    <React.StrictMode>
      <Provider store={store}>
        <div>
          <Notifications />
          <ConnectedRouter history={history}>{routes}</ConnectedRouter>
        </div>
      </Provider>
    </React.StrictMode>,
    document.getElementById('react-app'),
  )
}

renderApp()

// Allow Hot Module Replacement
if (module.hot) {
  module.hot.accept('./routes', () => {
    renderApp()
  })
}
